"use client"

import { cn } from "@/lib/utils"
import type { ChatMessageReactionCounts } from "@/lib/chat/message-reactions-ui"

export type ChatReactionPillsProps = {
  reactions?: ChatMessageReactionCounts
  viewerReaction?: string | null
  onToggle?: (emoji: string) => void
  className?: string
}

export function ChatReactionPills({
  reactions,
  viewerReaction,
  onToggle,
  className,
}: ChatReactionPillsProps) {
  if (!reactions) return null
  const entries = Object.entries(reactions).filter(([, count]) => (count ?? 0) > 0)
  if (entries.length === 0) return null

  return (
    <div className={cn("flex flex-wrap gap-1 mt-1", className)}>
      {entries.map(([emoji, count]) => {
        const selected = viewerReaction === emoji
        return (
          <button
            key={emoji}
            type="button"
            onClick={(e) => {
              e.stopPropagation()
              onToggle?.(emoji)
            }}
            className={cn(
              "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-sm transition-colors",
              selected
                ? "border-primary/40 bg-primary/10 dark:border-white/30 dark:bg-white/15"
                : "border-border bg-muted/80 dark:border-neutral-600 dark:bg-neutral-800",
            )}
            aria-pressed={selected}
          >
            <span>{emoji}</span>
            {count > 1 ? <span className="text-xs text-muted-foreground">{count}</span> : null}
          </button>
        )
      })}
    </div>
  )
}
